import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class strings, last conflicting utility wins.
 *
 * Moved here from the host's `src/lib/utils.ts` in #2169 PR-1, byte-identical.
 * It lives at the package ROOT rather than behind `./react` on purpose: it
 * needs no framework, and the host's `lib/utils.ts` re-exports it, so a `cn`
 * published from the React half would drag the whole primitive tree behind
 * every one of that module's sixty-odd importers.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
